import React from 'react';
import styles from './select.module.scss';
import { classnames } from '../util';

type onChange = (
  name: any,
  index: number,
  item: { key: string; code: string }
) => void;

export type SelectProps = {
  disabled: boolean;
  list: { key: string; code: string }[];
  placeholder: string;
  name: string;
  defaultValue?: number;
  headerTitle: string;
  listOpen: boolean;
  onChange: onChange;
};
const Select = ({
  onChange,
  name,
  disabled,
  placeholder,
  headerTitle,
  defaultValue,
  list,
}: SelectProps) => {
  const [listOpen, setListOpen] = React.useState(false);
  const [focusBtn, setFocusBtn] = React.useState<HTMLElement | null>(null);
  const toggleList = (e: any): void => {
    e.preventDefault();
    setListOpen(!listOpen);
  };
  const close = (): void => {
    setListOpen(false);
  };
  const selectItem = (name: string, item: any, index: number): void => {
    onChange(name, index, item);
    setListOpen(false);
  };
  const handleKeyDown = (
    event: React.KeyboardEvent,
    item: any,
    index: number
  ) => {
    const target = event.target as HTMLLIElement;
    if (event.key === 'Enter') {
      selectItem(name, item, index);
    }
    if (event.key === 'ArrowDown' && target.nextSibling) {
      (target.nextSibling as HTMLElement).focus();
    }
    if (event.key === 'ArrowUp' && target.previousSibling) {
      (target.previousSibling as HTMLElement).focus();
    }
    if (event.key === 'Escape') {
      toggleList(event);
      if (focusBtn) {
        focusBtn.focus();
      }
    }
  };
  const handleButtonFocus = (e: React.FocusEvent) => {
    e.persist();
    setFocusBtn(e.target as HTMLElement);
  };

  React.useEffect(() => {
    if (listOpen) {
      const listElements = document.querySelectorAll('ul li');
      if (listElements.length > 0) {
        (listElements[0] as HTMLElement).focus();
      }
    }
    return () => window.removeEventListener('click', close);
  }, [listOpen]);

  React.useEffect(() => {
    return () => window.removeEventListener('click', close);
  }, []);
  return (
    <button
      className={styles.Select + ' dropdown'}
      tabIndex={0}
      onClick={(e) => toggleList(e)}
      onFocus={handleButtonFocus}
      id='dropdown'
    >
      <div
        className={classnames(styles['select-header'], {
          [styles['disabled']]: disabled,
        })}
        aria-expanded={listOpen}
      >
        <div
          className={classnames(styles['placeholder'], {
            [styles['large-placeholder']]: !defaultValue && !headerTitle,
          })}
        >
          {placeholder}
        </div>
        <div className={styles['header-title']}>
          {headerTitle
            ? headerTitle
            : list[defaultValue || -1]
            ? list[defaultValue || -1].key
            : []}
        </div>
        {listOpen ? (
          <i className={styles['angle-down']} />
        ) : (
          <i className={styles['angle-up']} />
        )}
      </div>

      {listOpen && (
        <ul
          className={styles['select-list'] + ' dropdown-menu show'}
          onClick={(e) => e.stopPropagation()}
          aria-labelledby={placeholder}
        >
          {list.map((item, index) => (
            <li
              className={styles['select-list-item']}
              key={item.key ? item.key : index}
              onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                e.preventDefault();
                selectItem(name, item, index);
              }}
              tabIndex={0}
              onKeyDown={(e) => handleKeyDown(e, item, index)}
            >
              {item.key}
            </li>
          ))}
        </ul>
      )}
    </button>
  );
};

export default Select;
